<div class="padding">
  <div class="flex-container">
    <h1 class="left-box">{{this.batch?.description}}</h1>
    <span class="spacer"></span>
    @if (batch) {
      <lib-download-batch-documents
        [batch]="batch" class="margin-sides-5">
      </lib-download-batch-documents>
    }
    @if (showCompleteBatch()) {
    <button (click)="completeBatchConfirm()" mat-stroked-button color="primary" class="margin-sides-5">
      <mat-icon>double_arrow</mat-icon>
      {{ 'bundles.markBatchComplete' | transloco }}
    </button>
    }
  </div>
  <mat-card>
    @if (batch && this.bundle) {
      <mat-card-content>
        <div class="flex-container">
          <div class="flex-item">
            <div class="flex-container">
              <span class="flex-item">{{ 'common.labels.bundle' | transloco }}</span><a class="flex-item-2" [routerLink]="['/bundles', bundle!.id]" >{{ bundle!.name }}</a>
            </div>
            <div class="flex-container">
              <span class="flex-item">{{ 'bundles.description' | transloco }}</span><a class="flex-item-2">{{ bundle!.description }}</a>
            </div>
            <div class="flex-container">
              <span class="flex-item">{{ 'bundles.batch' | transloco }}</span><a class="flex-item-2">{{ batch!.description }}</a>
            </div>
            <div class="flex-container">
              <span class="flex-item">{{ 'common.labels.batchType' | transloco }}</span><a class="flex-item-2">{{ batch!.batchTypeID | enumLabel:'batchType' }}</a>
            </div>
            <div class="flex-container">
              <span class="flex-item">{{ 'common.labels.batchState' | transloco }}</span><a class="flex-item-2 bold">{{ batch!.batchState.name }}</a>
            </div>
            <div class="flex-container">
              <span class="flex-item">{{ 'bundles.requestedBy' | transloco }}</span><a class="flex-item-2 bold">{{ requestingUser }}</a>
            </div>
          </div>
          @if (totalProgress > 0) {
            <div class="flex-item">
              <div class="custom-progress-circle">
                <svg viewBox="0 0 36 36">
                  <path
                    class="background-circle"
                                d="M18 2.0845
                                    a 15.9155 15.9155 0 0 1 0 31.831
                                    a 15.9155 15.9155 0 0 1 0 -31.831">
                  </path>
                  <path
                    class="progress-circle"
                    [attr.stroke-dasharray]="100"
                    [attr.stroke-dashoffset]="100-(totalProgress*100)"
                                d="M18 2.0845
                                    a 15.9155 15.9155 0 0 1 0 31.831
                                    a 15.9155 15.9155 0 0 1 0 -31.831">
                  </path>
                </svg>
                <div class="progress-text">
                  <p data-testid="lein-lifetime-remaining-text">{{ 'bundles.totalProgress' | transloco: { percent: (totalProgress | percent) } }}</p>
                </div>
              </div>
            </div>
          }
          @if (totalProgress == 0) {
            <div class="flex-item">
              <mat-spinner></mat-spinner>
              <span>{{ 'bundles.countingOrders' | transloco: { count: batchSummary?.totalOrders } }}</span>
            </div>
          }
        </div>
        <mat-divider></mat-divider>
        @if (totalProgress > 0) {
          <div class="flex-container">
            <div class="custom-progress-circle">
              <svg viewBox="0 0 36 36">
                <path
                  class="background-circle"
                            d="M18 2.0845
                                a 15.9155 15.9155 0 0 1 0 31.831
                                a 15.9155 15.9155 0 0 1 0 -31.831">
                </path>
                <path
                  class="progress-circle"
                  [attr.stroke-dasharray]="100"
                  [attr.stroke-dashoffset]="100-stagedProgress"
                            d="M18 2.0845
                                a 15.9155 15.9155 0 0 1 0 31.831
                                a 15.9155 15.9155 0 0 1 0 -31.831">
                </path>
              </svg>
              <div class="progress-text">
                <p data-testid="lein-lifetime-remaining-text">{{ 'bundles.stagedProgress' | transloco: { done: batchSummary?.stagedOrders, total: batchSummary?.totalOrders } }}</p>
              </div>
            </div>
            <div class="custom-progress-circle">
              <svg viewBox="0 0 36 36">
                <path
                  class="background-circle"
                            d="M18 2.0845
                                a 15.9155 15.9155 0 0 1 0 31.831
                                a 15.9155 15.9155 0 0 1 0 -31.831">
                </path>
                <path
                  class="progress-circle"
                  [attr.stroke-dasharray]="100"
                  [attr.stroke-dashoffset]="100-processedProgress"
                            d="M18 2.0845
                                a 15.9155 15.9155 0 0 1 0 31.831
                                a 15.9155 15.9155 0 0 1 0 -31.831">
                </path>
              </svg>
              <div class="progress-text">
                <p data-testid="lein-lifetime-remaining-text">{{ 'bundles.processedProgress' | transloco: { done: batchSummary?.processedOrders, total: batchSummary?.totalOrders } }}</p>
              </div>
            </div>
            <div class="custom-progress-circle">
              <svg viewBox="0 0 36 36">
                <path
                  class="background-circle"
                            d="M18 2.0845
                                a 15.9155 15.9155 0 0 1 0 31.831
                                a 15.9155 15.9155 0 0 1 0 -31.831">
                </path>
                <path
                  class="progress-circle"
                  [attr.stroke-dasharray]="100"
                  [attr.stroke-dashoffset]="100-submittedProgress"
                            d="M18 2.0845
                                a 15.9155 15.9155 0 0 1 0 31.831
                                a 15.9155 15.9155 0 0 1 0 -31.831">
                </path>
              </svg>
              <div class="progress-text">
                <p data-testid="lein-lifetime-remaining-text">{{ 'bundles.submittedProgress' | transloco: { done: batchSummary?.submittedOrders, total: batchSummary?.totalOrders } }}</p>
              </div>
            </div>
            <div class="custom-progress-circle">
              <svg viewBox="0 0 36 36">
                <path
                  class="background-circle"
                            d="M18 2.0845
                                a 15.9155 15.9155 0 0 1 0 31.831
                                a 15.9155 15.9155 0 0 1 0 -31.831">
                </path>
                <path
                  class="progress-circle"
                  [attr.stroke-dasharray]="100"
                  [attr.stroke-dashoffset]="100-completedProgress"
                            d="M18 2.0845
                                a 15.9155 15.9155 0 0 1 0 31.831
                                a 15.9155 15.9155 0 0 1 0 -31.831">
                </path>
              </svg>
              <div class="progress-text">
                <p data-testid="lein-lifetime-remaining-text">{{ 'bundles.completeProgress' | transloco: { done: batchSummary?.completedOrders, total: batchSummary?.totalOrders } }}</p>
              </div>
            </div>
          </div>
        }
        <mat-divider></mat-divider>
        @if (stagedProgress >= 100) {
          <app-batch-orders-list [batch]="batch"></app-batch-orders-list>
        }
      </mat-card-content>
    }
  </mat-card>
</div>